import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

export const ContactListsPage = () => {
  return <NuqsAdapter>Contact Lists Page</NuqsAdapter>;
};
